import * as api from "api/endpoints/workflowReport";
import { createSlice, createSliceSelector } from "../factory";

const name = "reportsPage";

const initialState = {
  reportsData: null,
  historyData: null,
  historyError: null
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectReportsData = createSelector((state) => {
  return state.reportsData;
});

export const selectHistoryData = createSelector((state) => {
  return state.historyData;
});

export const selectHistoryError = createSelector((state) => {
  return state.historyError;
});

/* Actions */
const { update } = slice.actions;

export function loadEpExport(partnerReportsId) {
  const config = { params: { partnerReportsId } };

  return async function (dispatch) {
    const data = await api.exportReports(config);

    const link = document.createElement("a");
    link.href = data.epFileURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
}

export function loadEpHistory(partnerReportsId, pageNo) {
  const config = { params: { partnerReportsId, pageNo, pageSize: 5 } };

  return async function (dispatch) {
    try {
      const data = await api.getHistory(config);
      const payload = { historyData: data };
      dispatch(update(payload));
    } catch (err) {
      const payload = { historyError: err.name };
      dispatch(update(payload));
    }
  };
}

export function clearEpHistory() {
  return async function (dispatch) {
    const payload = { historyData: null };
    dispatch(update(payload));
  };
}
